import { useEffect } from "react";
import { installDashSanitizer } from "@/lib/typography-dom";

/**
 * Włącza runtime'ową sanitizację myślników w całym DOM.
 * Bez widocznego interfejsu — wcześniejszy podgląd różnic
 * w trybie deweloperskim został usunięty na prośbę użytkowniczki.
 */
export function TypographyGuard() {
  useEffect(() => installDashSanitizer(), []);

  return null;
}
